import { FC } from 'react';
import classnames from 'classnames';

interface Props {
  isSelected: boolean;
  className?: string;
  innerClassName?: string;
}

const RadioButton: FC<Props> = ({ isSelected, className, innerClassName }) => {
  return (
    <div
      className={classnames(
        'flex items-center justify-center w-[16px] h-[16px] border-[0.5px] border-brand-border rounded-full bg-brand-card',
        className,
      )}
    >
      <div
        className={classnames('w-[10px] h-[10px] rounded-full transition-all duration-300', innerClassName, {
          'bg-brand-primary': isSelected,
        })}
      />
    </div>
  );
};

export default RadioButton;
